export const API_BASE_URL = 'https://concours.formanet-tn.com/api';
export const URL_DASHBOARD='https://concours.formanet-tn.com/app_phct/public/uploads/Sujet';
// export const API_BASE_URL = 'http://localhost:8080/Concours/api';
// export const URL_DASHBOARD='http://localhost:8080/Concours/app_phct/public/uploads/Sujet';
